export const isPermitted = (permissions, allowed) => {
  let perm = false;
  if (permissions) {
    allowed?.forEach((element) => {
      permissions?.forEach((permission) => {
        if (permission?.toLowerCase() === element?.toLowerCase()) {
          perm = true;
        }
      });
    });
  }

  return perm;
};
